import { render, staticRenderFns } from "./bootstrap-grid.html?vue&type=template&id=77d48540&scoped=true&"
import script from "./bootstrap-grid.ts?vue&type=script&lang=js&"
export * from "./bootstrap-grid.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d48540",
  null
  
)

export default component.exports